import { Capacitor } from "@capacitor/core";

const getPlatformInfo = () => {
  let userAgent = navigator.userAgent; // Fix for opera error

  let isMobileBrowser; // Introduce a general mobile browser flag
  let isIosBrowser;
  let isAndroidBrowser;
  let isDesktopBrowser;
  let isMobile = Capacitor.isNativePlatform();

  const isIPadDesktopMode =
    /Macintosh/i.test(userAgent) &&
    navigator.maxTouchPoints > 0 &&
    navigator.platform === "MacIntel";

  if (/iPad|iPhone|iPod/.test(userAgent) || isIPadDesktopMode) {
    isMobileBrowser = true;
    isIosBrowser = true;
    isAndroidBrowser = false;
    isDesktopBrowser = false;
  } else if (/android/i.test(userAgent)) {
    isMobileBrowser = true;
    isIosBrowser = false;
    isAndroidBrowser = true;
    isDesktopBrowser = false;
  } else {
    isMobileBrowser = false;
    isIosBrowser = false;
    isAndroidBrowser = false;
    isDesktopBrowser = true;
  }

    return { isMobile, isMobileBrowser, isIosBrowser, isAndroidBrowser, isDesktopBrowser };
};

const { isMobile, isMobileBrowser, isIosBrowser, isAndroidBrowser, isDesktopBrowser } = getPlatformInfo();
export const IS_MOBILE = isMobile;
export const IS_MOBILE_BROWSER = isMobileBrowser;
export const IS_IOS_BROWSER = isIosBrowser;
export const IS_ANDROID_BROWSER = isAndroidBrowser;
export const IS_DESKTOP_BROWSER = isDesktopBrowser;
